module.exports = __webpack_public_path__ + "img/kr.90326d72.svg";